import React, {useEffect}  from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import Card from "components/card";
import { 
	getTrainingClassModuleList, 
} from "../../../redux/trainingclass/trainingClassState";
import ModuleProgressCard from "./components/ModuleProgressCard";
import dayjs from "dayjs";

const ViewTrainingOverview = ({recordList, 
	pagination, 
	doSearch, 
	filters,
	requesting,
	error,
}) => {

	const { courseId } = useParams();

	useEffect(() => {
		doSearch({ classeId:courseId, paginate: pagination?.per_page});
	}, [doSearch, pagination?.per_page]);

	const formatSchedule = (from, to) => {
		if (!from || !to) return "No schedule available";
		return `${dayjs(from).format("MMM DD, YYYY")} → ${dayjs(to).format("MMM DD, YYYY")}`;
	};
    
	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<Card extra={"w-full h-full p-4"}>
					{recordList && recordList.length > 0 ? (
						recordList.map((item) => (
						<ModuleProgressCard
							key={item.tcm_id}
							moduleData={item}
						/>
					))
						) : (
							<p className="text-gray-500 text-center col-span-full">
								No available classes found.
							</p>
						)}   
				</Card>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	recordList: state.trainingClass.trainingClassModuleList?.items,
	pagination: state.trainingClass.trainingClassModuleList?.pagination,
	filters: state.trainingClass.trainingClassModuleList?.filters,
	requesting: state.trainingClass.trainingClassModuleList?.requesting,
	error: state.trainingClass.trainingClassModuleList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getTrainingClassModuleList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTrainingOverview);